import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
    SelectLabel,
} from 'components/shadcn/ui/select';
import { DeviceTypes } from 'components/DeviceDetails/constants';

const getDeviceSN = (device) =>
    typeof device === 'string'
        ? device.trim()
        : (device?.SerialNumber ?? device?.MASTER_SN ?? device?.PACK_SN);

const DeviceDropdown = ({ devices, selectedDevice, setSelectedDevice, deviceType }) => {
    const devicesSerialNumbers = devices.map((device) => {
        if (typeof device === 'string') {
            const sn = device.trim();
            return { label: sn, value: sn };
        }
        return {
            label: device?.ThingName ?? device?.MasterName ?? device?.PackName ?? device?.PACK_SN,
            value: device?.SerialNumber ?? device?.MASTER_SN ?? device?.PACK_SN,
        };
    });

    if (!selectedDevice || devices?.length <= 1) return null;

    const currentValue = getDeviceSN(selectedDevice);

    const handleValueChange = (value) => {
        const newDevice = devices.find((device) => getDeviceSN(device) === value);
        setSelectedDevice(newDevice);
    };

    return (
        <div className="m-0 p-0">
            <label htmlFor="device" className="text-sm">
                {deviceType === DeviceTypes.EMS ? 'BMS' : 'Module'}
            </label>
            <Select
                id="device"
                value={currentValue}
                onValueChange={handleValueChange}
            >
                <SelectTrigger className="w-full gap-2 sm:w-max">
                    <SelectValue placeholder="Select Device" />
                </SelectTrigger>
                <SelectContent>
                    {devicesSerialNumbers.map((device) => (
                        <SelectItem
                            key={device.value}
                            value={device.value}
                        >
                            {device.label}
                        </SelectItem>
                    ))}
                </SelectContent>
            </Select>
        </div>
    );
};

export default DeviceDropdown;
